import axios from 'axios';
import { API_HOST } from '../../consts';

const cancelTicket = (id) =>
  axios
    .patch(`${API_HOST}/tickets/tickets/${id}/cancel`)
    .then((response) => response.data);

export default cancelTicket;
